module.exports = __webpack_public_path__ + "img/treasurehunt@3x.0fb1e479.png";